var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPaidContent = function SvgPaidContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "evenodd",
    d: "M17.368 16.025c-.27 0-.49.22-.49.491 0 .106.036.18.127.259.108.093.28.179.518.257.309.1.636.237.888.465.276.248.438.583.438 1.001 0 .825-.67 1.482-1.481 1.482-.818 0-1.49-.654-1.49-1.482a.5.5 0 0 1 1 0c0 .265.214.482.49.482a.482.482 0 0 0 .481-.482c0-.129-.038-.196-.108-.259-.093-.084-.256-.169-.527-.256h-.002c-.284-.094-.605-.23-.862-.453a1.309 1.309 0 0 1-.473-1.014c0-.823.668-1.491 1.49-1.491a1.49 1.49 0 0 1 1.482 1.491.5.5 0 0 1-1 0 .49.49 0 0 0-.481-.491Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "evenodd",
    d: "M17.366 14.478a.5.5 0 0 1 .5.5v.555a.5.5 0 0 1-1 0v-.555a.5.5 0 0 1 .5-.5ZM17.367 18.985a.5.5 0 0 1 .5.5v.563a.5.5 0 0 1-1 0v-.563a.5.5 0 0 1 .5-.5Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "evenodd",
    d: "M17.504 13a4.5 4.5 0 1 0-.009 9 4.5 4.5 0 0 0 .01-9ZM12 17.5c0-3.033 2.465-5.5 5.504-5.5A5.504 5.504 0 0 1 23 17.5a5.5 5.5 0 1 1-11 0Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "evenodd",
    d: "M1 3.21C1 2.036 1.884 1 3.06 1H22v13.5a.5.5 0 0 1-1 0V2H3.06C2.52 2 2 2.501 2 3.21V19h10.5a.5.5 0 0 1 0 1H1V3.21Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M14.247 10.002 9.864 7.25v5.503l4.383-2.751Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "evenodd",
    d: "M5.5 1a.5.5 0 0 1 .5.5v18a.5.5 0 0 1-1 0v-18a.5.5 0 0 1 .5-.5ZM17.5 1a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-1 0v-11a.5.5 0 0 1 .5-.5Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    fillRule: "evenodd",
    d: "M1 4.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM1 7.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM1 10.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM1 13.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM1 16.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM17 4.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM17 7.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5ZM17 10.5a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1h-4a.5.5 0 0 1-.5-.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgPaidContent;